module.exports = __webpack_public_path__ + "static/media/homepage4.af4e4f72.svg";